import { render, staticRenderFns } from "./StudentWrongQuestionBook.vue?vue&type=template&id=f4b62c54&scoped=true"
import script from "./StudentWrongQuestionBook.vue?vue&type=script&lang=js"
export * from "./StudentWrongQuestionBook.vue?vue&type=script&lang=js"
import style0 from "./StudentWrongQuestionBook.vue?vue&type=style&index=0&id=f4b62c54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b62c54",
  null
  
)

export default component.exports